import { ProductCategoryFilter } from './product-category-filter.model';
import { PageModel } from './page.model';
import { StringCategoryFilter } from './filter-backend';

export class AccessoryCategoryFilter implements ProductCategoryFilter {
  paging: PageModel;
  categoryId: number;
  productId: string;
  carMake: StringCategoryFilter;
  carYear: StringCategoryFilter;
  carModel: StringCategoryFilter;
  carSubmodel: StringCategoryFilter;
}
